import { BrowserRouter as Router, Routes, Route } from "react-router-dom";
import LandingPage from './Component/MainComps/LandingPage';
import Aboutus from './Component/MainComps/Aboutus';
import FAQs from './Component/MainComps/FAQs';
import Contact from './Component/MainComps/Contact';
import ErrorPage from './Component/Miscellaneous/ErrorPage';
import Menu from './Component/MainComps/Menu';

const RoutingPage = () => {
    return (
        <>
            <Router>
                <Routes>

                    <Route exact path="/" element={<LandingPage />}></Route>
                    <Route exact path="/aboutus" element={<Aboutus />}></Route>
                    <Route exact path="/faqs" element={<FAQs />}></Route>
                    <Route exact path="/contact" element={<Contact />}></Route>
                    <Route exact path="/menu" element={<Menu />}></Route>
                    <Route exact path="*" element={<ErrorPage />}></Route>

                </Routes>
            </Router>
        </>
    )
}

export default RoutingPage